// ATDS
export const isAdmin = (role?: string): boolean =>
  role ? role.includes("A") : false;
export const isTeacher = (role?: string): boolean =>
  role ? role.includes("T") : false;
export const isDataOp = (role?: string): boolean =>
  role ? role.includes("D") : false;
export const isSolver = (role?: string): boolean =>
  role ? role.includes("S") : false;

export const isNoRoles = (role?: string): boolean =>
  role ? role.trim().length == 0 : true;

// if role contains at least one of the roles[] it returns true
export const isOneOfRoles = (roles: string[], role?: string): boolean => {
  if (!role) {
    return false;
  }
  return roles.some((r) => role.includes(r));
};
